const apiBase = process.env.NODE_ENV === 'production' ? 'https://honeyshare.live/' : '/';

export let settings = {
  APIBase: apiBase,
  PageSize: 50,
}
